function formatAge(age: string): string;
function formatAge(age: Date): string;
function formatAge(age: string | Date | null | undefined): string;

function formatAge(age: string | Date | null | undefined): string {
  if (!age) {
    return "";
  }

  const ageDate = age instanceof Date ? age : new Date(age);
  const now = new Date();
  const diffMs = now.getTime() - ageDate.getTime();
  const diffDays = Math.round(diffMs / (24 * 60 * 60 * 1000));

  if (diffDays === 0) {
    return "Today";
  } else if (diffDays < 7) {
    return `${diffDays} day${diffDays !== 1 ? "s" : ""}`;
  } else if (diffDays < 28) {
    const weeks = Math.round(diffDays / 7);
    return `${weeks} week${weeks !== 1 ? "s" : ""}`;
  } else if (diffDays <= 365) {
    const months = Math.round(diffDays / 30.44);
    return `${months} month${months !== 1 ? "s" : ""}`;
  } else {
    const years = Math.round(diffDays / 365.25);
    return `${years} year${years !== 1 ? "s" : ""}`;
  }
}

export { formatAge };
